import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { ISnippet } from 'src/services/api/snippets/types';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_SNIPPETS_PATH } from 'src/services/api/snippets/constants';
import { getApiErrorMessage } from 'src/services/api/utils';

export const useDeleteSnippet = (id?: number) => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<void, IStandardErrorResponse>(
        async () => {
            const path = `${GET_SNIPPETS_PATH}/${id}`;
            await apiClient(path, { method: 'delete' });
        }, {
            onSuccess: () => {
                addNotification('Snippet deleted', 'success');

                queryClient.setQueryData<ISnippet[]>(queryKeys.snippets, (oldData) => {
                    if (!oldData) {
                        return [];
                    }

                    return oldData.filter((snippet) => snippet.id !== id);
                });

                queryClient.removeQueries([queryKeys.snippets, id]);
            },
            onError: (error) => {
                const errorMessage = getApiErrorMessage(error) || 'Failed to delete snippet';
                addNotification(errorMessage, 'error');
            }
        });
};